import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../../../css/loans.css';
import '../../../css/star-rating.css';
import { url } from '../../../js/api/endpoint';
import datetimePicker from '../../../js/components/pickertime.js';
import discountTable from '../../../js/api/discount-table.js';
import language from '../../../js/stores/language.js';
import contact from '../../../js/stores/contact.js';
import carLoan from '../../../js/stores/car-loan.js';
import buyoutDeposit from '../../../js/stores/buyout-deposit.js';
//import discount from '../../../js/stores/discount.js';
import * as dayjs from 'dayjs';
import CarFeaturesReadOnly from '../../car/components/features-read-only.f7.html';
import advent from '../../../js/controllers/advent.js';
import fixedHolidays from '../../../js/controllers/fixed-holidays.js';
import googleMaps from '../../../js/controllers/google-map-lib.js';
import restrictedDatesLibrary from '../../../js/controllers/restricted-dates-lib.js';
import RatingDisplayMini from './rating-display-mini.f7.html';
import downloadLoanAgreementDoc from '../../../js/components/loan-agreement-document.js';
var RequestTab = function RequestTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router,
    $emit = _ref.$emit;
  var lang = language.getters.Item.value;
  var data = props.data.CarMainData;
  var calendarDefault;
  var calendarRange;
  var calendarRangeDefaultValue = '';
  var carLoanData = props.data.CarLoanData;
  var extraDriverData = props.data.ExtraDriverData;
  var extraDriverFields = ['name', 'last-name', 'birth-date', 'address-street', 'address-exterior-number', 'district', 'zipcode', 'cellphone', 'email', 'location'];
  //let discountTable;
  var requesterBirthDate = null;
  var buyoutList = [];
  var holidayList = [];
  var datesInRange = [];
  var ongoingDates = [];
  var restricedDates = [];
  var recommendationLabel = "";
  var downloadDocument = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(props.data.CarLoanData.CarLoanStatusId < 3)) {
              _context.next = 1;
              break;
            }
            $f7.toast.show({
              text: 'Document is not ready yet'
            });
            return _context.abrupt("return");
          case 1:
            downloadLoanAgreementDoc(props.data);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function downloadDocument(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var extraSetup = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var borrowerContactData;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return googleMaps.initAutocomplete("#extra-driver-contact");
          case 1:
            if (!(props.data.CarLoanData.CarLoanId < 1)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 2;
            return contact.dispatch('getSelfData');
          case 2:
            borrowerContactData = _context2.sent;
            if (borrowerContactData.status !== undefined && borrowerContactData.status !== 200) {
              console.log(borrowerContactData.data.messages.error);
            }
            requesterBirthDate = borrowerContactData.ContactBirthDate;
          case 3:
            $update();
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function extraSetup() {
      return _ref3.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var startDate, endDate, buyoutData, timeElapsed, today, cfgStartTime, cfgEndTime, disabledDates, parts, tempDate;
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          //discountTable = await discount.dispatch('getAvailableTree');
          //carLoanData
          //extraDriverData = carLoanData.ExtraDriverContactId;

          if (props.data.CarLoanData.CarLoanId > 0) {
            startDate = props.data.CarLoanData.CarLoanStartDate;
            endDate = props.data.CarLoanData.CarLoanEndDate;
            calendarRangeDefaultValue = "".concat(startDate, " - ").concat(endDate);
          }
          if (!(Number(props.data.CarLoanData.CarLoanStatusId) > 1)) {
            _context3.next = 1;
            break;
          }
          return _context3.abrupt("return");
        case 1:
          setTimeout(function () {
            extraSetup();
          }, 500);
          if (!(props.data.CarLoanData.CarLoanId < 1)) {
            _context3.next = 4;
            break;
          }
          _context3.next = 2;
          return buyoutDeposit.dispatch('getListActive');
        case 2:
          buyoutData = _context3.sent;
          if (buyoutData.status !== undefined && buyoutData.status !== 200) {
            console.log(buyoutData.data.messages.error);
          }
          buyoutList = buyoutData;
          recommendationLabel = buyoutList[0].BuyoutDepositRecommendationLabel;
          timeElapsed = Date.now();
          today = new Date(timeElapsed);
          cfgStartTime = datetimePicker.timeConfig('#loan-period-start-time');
          cfgEndTime = datetimePicker.timeConfig('#loan-period-end-time');
          $f7.picker.create(cfgStartTime);
          $f7.picker.create(cfgEndTime);
          disabledDates = [];
          _context3.next = 3;
          return restrictedDatesLibrary.refreshDisabledDates(props.data.CarMainData.CarId);
        case 3:
          ongoingDates = restrictedDatesLibrary.listOngoing;
          restricedDates = restrictedDatesLibrary.listRestricted;
          disabledDates = restrictedDatesLibrary.disabledDates;
          calendarRange = $f7.calendar.create({
            inputEl: '#loan-period-range',
            dateFormat: 'yyyy-mm-dd',
            openIn: 'customModal',
            footer: true,
            toolbarCloseText: lang.translate('general.done'),
            rangePickerMaxDays: 30,
            disabled: disabledDates,
            rangePicker: true,
            on: {
              closed: function closed(e) {
                calculateLoanCost(e);
              }
            }
          });
          calendarDefault = $f7.calendar.create({
            inputEl: '#extra-driver-contact-birth-date',
            openIn: 'customModal',
            dateFormat: 'yyyy-mm-dd',
            header: true,
            footer: true,
            closeOnSelect: true,
            headerPlaceholder: lang.translate('user.edit.personal.contactBirthDateLabel'),
            toolbarCloseText: lang.translate('general.done'),
            on: {
              closed: function closed(e) {
                if (e.value === undefined) return;
                var rangeDates = e.value;
                var startDate = dayjs(rangeDates[0]).format('YYYY-MM-DD');
                document.getElementById("extra-driver-contact-birth-date").value = "".concat(startDate);
              }
            }
          });
        case 4:
          //Enable when recovering an external driver
          if (props.data.ExtraDriverData.ContactBirthDate != null) {
            parts = props.data.ExtraDriverData.ContactBirthDate.split('-');
            tempDate = new Date(parts[0], parts[1] - 1, parts[2]);
            calendarDefault.setValue([tempDate]);
          }
          $update();
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  $on('pageBeforeRemove', function () {
    calendarRange.destroy();
    calendarDefault.destroy();
  });
  var showRangeCalendar = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            calendarRange.open();
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function showRangeCalendar() {
      return _ref5.apply(this, arguments);
    };
  }();
  var showBirthCalendar = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            calendarDefault.open();
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function showBirthCalendar() {
      return _ref6.apply(this, arguments);
    };
  }();
  var calculateLoanCost = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
      var rangeDates, startDate, timeElapsed, today, diffToday, lastDate, b, diffHours, diffDay, diffWeek, endDate, element, customValue, temp, basePrice, buyoutDepositToPay, buyoutDepositFee, discountPercent, previousToPay, daysToGoAbroad, totalDiscount, driverAge, diffAge, under26Age, serviceFee, adminstrativeFee, weekendSurchargePercent, weekendSurcharge, totalHolidays, holidaySurcharge, subTotalToPay, taxes, totalToPay, invoiceDetails;
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(e.value === undefined)) {
              _context6.next = 1;
              break;
            }
            return _context6.abrupt("return");
          case 1:
            rangeDates = e.value;
            startDate = dayjs(rangeDates[0]).format('YYYY-MM-DD');
            document.getElementById('loan-period-range').value = "".concat(startDate);
            if (!(e.value.length < 2)) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return");
          case 2:
            timeElapsed = Date.now();
            today = new Date(timeElapsed);
            diffToday = dayjs(rangeDates[0]).diff(today, 'd');
            if (diffToday < 3) {
              $f7.toast.show({
                text: lang.translate('loan.request.onLoanPeriodAtLeast3Days')
              });
            }
            lastDate = dayjs(rangeDates[1]);
            b = lastDate.add(24, 'h');
            diffHours = b.diff(rangeDates[0], 'h');
            diffDay = lastDate.diff(rangeDates[0], 'd') + 1;
            if (diffHours > 720) {
              $f7.toast.show({
                text: lang.translate('loan.request.onLoadPeriodGreater30Days')
              });
            }
            diffWeek = lastDate.diff(rangeDates[0], 'w');
            endDate = dayjs(rangeDates[1]).format('YYYY-MM-DD');
            if (diffDay == 7 || diffDay == 14 || diffDay == 21 || diffDay > 27) diffWeek++;
            diffWeek = diffWeek > 4 ? 4 : diffWeek;
            element = document.getElementById("buyout-deposit-id");
            customValue = element.value;
            temp = buyoutList.filter(function (item) {
              return Number(item.BuyoutDepositId) == Number(customValue);
            })[0];
            if (customValue.length == 0) {
              temp = {
                BuyoutDepositToPay: 0,
                BuyoutDepositFee: 0
              };
            }
            basePrice = parseInt(data.CarPriceRent, 10);
            buyoutDepositToPay = Number(temp.BuyoutDepositToPay);
            buyoutDepositFee = Number(temp.BuyoutDepositFee);
            discountPercent = diffHours < 145 ? discountTable['d']['values'][String(diffDay)] : discountTable['w']['values'][String(diffWeek)];
            previousToPay = basePrice * diffDay;
            daysToGoAbroad = 0; //document.getElementById("go-abroad").checked ? diffDay : 0;
            totalDiscount = previousToPay * (discountPercent / 100);
            totalDiscount = parseFloat((Math.round(totalDiscount * 100) / 100).toFixed(2));
            driverAge = requesterBirthDate;
            diffAge = dayjs(today).diff(driverAge, 'y');
            under26Age = 0; //(diffAge < 26) ? 2 * diffDay : 0;
            serviceFee = diffDay;
            adminstrativeFee = 9.85;
            weekendSurchargePercent = weekendRate(dayjs(rangeDates[0]), dayjs(rangeDates[1]).format('YYYY-MM-DD 23:59:59'));
            weekendSurcharge = basePrice * (weekendSurchargePercent / 100);
            weekendSurcharge = parseFloat((Math.round(weekendSurcharge * 100) / 100).toFixed(2));
            totalHolidays = calculateHolidays(rangeDates[0], rangeDates[1]);
            holidaySurcharge = basePrice * 0.1 * totalHolidays;
            /*0.1 = 10% Fixed by now*/
            holidaySurcharge = parseFloat((Math.round(holidaySurcharge * 100) / 100).toFixed(2));
            subTotalToPay = previousToPay - totalDiscount + daysToGoAbroad + weekendSurcharge + serviceFee + adminstrativeFee + under26Age + holidaySurcharge + buyoutDepositToPay + buyoutDepositFee;
            subTotalToPay = parseFloat((Math.round(subTotalToPay * 100) / 100).toFixed(2));
            taxes = subTotalToPay * 21 / 100;
            taxes = parseFloat((Math.round(taxes * 100) / 100).toFixed(2));
            totalToPay = subTotalToPay + taxes;
            totalToPay = parseFloat((Math.round(totalToPay * 100) / 100).toFixed(2));
            invoiceDetails = {
              "BasePrice": basePrice,
              "BuyoutDepositFee": buyoutDepositFee,
              "BuyoutDepositToPay": buyoutDepositToPay,
              "SubTotalToPay": subTotalToPay,
              "Discount": discountPercent,
              "DaysToGoAbroad": daysToGoAbroad,
              "TotalDiscount": totalDiscount,
              "WeekendSurchargePercent": weekendSurchargePercent,
              "WeekendSurcharge": weekendSurcharge,
              "HolidaySurcharge": holidaySurcharge,
              "DaysToBorrow": diffDay,
              "WeeksToBorrow": diffWeek,
              "ServiceFee": serviceFee,
              "AdminstrativeFee": adminstrativeFee,
              "Under26Age": under26Age,
              "Taxes": taxes,
              "TotalToPay": totalToPay
            };
            $emit('eventPrice', invoiceDetails);
            document.getElementById('car-price-per-day').value = data.CarPriceRent;
            document.getElementById('total-to-pay').value = totalToPay;
            document.getElementById('days-to-borrow').value = diffDay;
            document.getElementById('discounts').value = totalDiscount;
            document.getElementById('is-going-abroad').value = daysToGoAbroad > 0 ? 1 : 0;
            document.getElementById('car-loan-start-date').value = startDate;
            document.getElementById('car-loan-end-date').value = endDate;
            document.getElementById('loan-period-range').value = "".concat(startDate, " - ").concat(endDate);
            $update();
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function calculateLoanCost(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();
  var triggerCalc = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
      return _regeneratorRuntime.wrap(function (_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            recommendationLabel = e.target.selectedIndex > 1 ? e.target.options[e.target.selectedIndex].dataset.label : e.target.options[1].dataset.label;
            calculateLoanCost(calendarRange);
            $update();
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function triggerCalc(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();
  var toggleExtraDriver = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            document.getElementById('extra-driver-div').classList.toggle('disabled');
            if (!e.target.checked) {
              $f7.accordion.open('.extra-driver');
              document.getElementById('has-extra-driver').value = 1;
            } else {
              $f7.accordion.close('.extra-driver');
              document.getElementById('has-extra-driver').value = 0;
            }
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function toggleExtraDriver(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();
  var weekendRate = function weekendRate(date1, date2) {
    var startDate = new Date(date1),
      endDate = new Date(date2);
    var isOnWeekend = 0;
    var isFullOrMore = 0;
    while (startDate < endDate) {
      var day = startDate.getDay();

      // if one weekend is found, check the next date
      if (day === 6 || day === 0) {
        isOnWeekend++;
        var nextDate = new Date(startDate);
        nextDate.setDate(startDate.getDate() + 1); // set the next date
        var nextDay = nextDate.getDay(); // get the next day

        if (nextDay === 6 || nextDay === 0) {
          isFullOrMore++;
        }
      }
      startDate.setDate(startDate.getDate() + 1);
    }
    if (isOnWeekend == 1) {
      return 6;
    }
    if (isFullOrMore > 0) {
      return 10;
    }
    return 0;
  };
  var calculateHolidays = function calculateHolidays(startDate, endDate) {
    var getYear = dayjs(startDate).year();
    var totalHolidays = 0;
    datesInRange = getDatesInRange(dayjs(startDate).toDate(), dayjs(endDate).toDate());
    holidayList = fixedHolidays.list(getYear);
    totalHolidays = datesInRange.filter(function (searchDate) {
      return holidayList.find(function (holidayDate) {
        return searchDate.getTime() == holidayDate.getTime();
      });
    }).length;
    return totalHolidays;
  };
  var getDatesInRange = function getDatesInRange(startDate, endDate) {
    var date = new Date(startDate.getTime());
    var dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  };
  var saveRequest = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
      var extraDriverAge, diffAgeToday, rangeDates, timeElapsed, today, diffToday, lastDate, b, diffHours, datesInRange, totalOngoingDates, totalRestrictedDates;
      return _regeneratorRuntime.wrap(function (_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            if (document.getElementById('borrower-acceptance-agreement').checked) {
              _context0.next = 1;
              break;
            }
            $f7.toast.show({
              text: lang.translate('user.newAccount.userAcceptAgreementMessage')
            });
            document.getElementById('borrower-acceptance-agreement').focus();
            return _context0.abrupt("return");
          case 1:
            if (!(document.getElementById('buyout-deposit-id').selectedIndex === 0)) {
              _context0.next = 2;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.buyoutDepositOption')
            });
            return _context0.abrupt("return");
          case 2:
            if (!(calendarRange.value == undefined || calendarRange.value.length == 1)) {
              _context0.next = 3;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.messageRangeDate')
            });
            return _context0.abrupt("return");
          case 3:
            if (document.getElementById('get-extra-driver').checked) {
              _context0.next = 5;
              break;
            }
            if (validateContactData()) {
              _context0.next = 4;
              break;
            }
            return _context0.abrupt("return");
          case 4:
            extraDriverAge = calendarDefault.value;
            diffAgeToday = dayjs(today).diff(extraDriverAge, 'y');
            if (!(diffAgeToday < 21)) {
              _context0.next = 5;
              break;
            }
            $f7.toast.show({
              text: lang.translate('user.edit.personal.contactNotAdultMessage')
            });
            return _context0.abrupt("return");
          case 5:
            rangeDates = calendarRange.value;
            timeElapsed = Date.now();
            today = new Date(timeElapsed);
            diffToday = dayjs(rangeDates[0]).diff(today, 'd');
            if (!(diffToday < 3)) {
              _context0.next = 6;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.onLoanPeriodAtLeast3Days')
            });
            return _context0.abrupt("return");
          case 6:
            lastDate = dayjs(rangeDates[1]);
            b = lastDate.add(24, 'h');
            diffHours = b.diff(rangeDates[0], 'h');
            if (!(diffHours > 720)) {
              _context0.next = 7;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.onLoadPeriodGreater30Days')
            });
            return _context0.abrupt("return");
          case 7:
            datesInRange = getDatesInRange(dayjs(rangeDates[0]).toDate(), dayjs(rangeDates[1]).toDate());
            totalOngoingDates = ongoingDates.filter(function (searchDate) {
              return datesInRange.find(function (innerDate) {
                return searchDate.getTime() == innerDate.getTime();
              });
            }).length;
            if (!(totalOngoingDates > 0)) {
              _context0.next = 8;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.messageOngoingDates')
            });
            return _context0.abrupt("return");
          case 8:
            totalRestrictedDates = restricedDates.filter(function (searchDate) {
              return datesInRange.find(function (innerDate) {
                return searchDate.getTime() == innerDate.getTime();
              });
            }).length;
            if (!(totalRestrictedDates > 0)) {
              _context0.next = 9;
              break;
            }
            $f7.toast.show({
              text: lang.translate('loan.request.messageRestrictedDates')
            });
            return _context0.abrupt("return");
          case 9:
            $f7.dialog.password(lang.translate('loan.request.confirmSaveRequest'), /*#__PURE__*/function () {
              var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(password) {
                var formRequestCarData, formExtraDriverData, extraContactId, _result, result;
                return _regeneratorRuntime.wrap(function (_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      formRequestCarData = $f7.form.convertToData('#request-car-form');
                      formExtraDriverData = $f7.form.convertToData('#extra-driver-data-form');
                      formRequestCarData['UserPassword'] = password;
                      extraContactId = 0;
                      if (document.getElementById('get-extra-driver').checked) {
                        _context9.next = 3;
                        break;
                      }
                      formExtraDriverData['UserPassword'] = password;
                      _context9.next = 1;
                      return contact.dispatch('createSecured', formExtraDriverData);
                    case 1:
                      _result = _context9.sent;
                      if (!(_result.status !== undefined && _result.status !== 201)) {
                        _context9.next = 2;
                        break;
                      }
                      $f7.toast.show({
                        text: _result.data.messages.error
                      });
                      return _context9.abrupt("return");
                    case 2:
                      extraContactId = _result.data;
                    case 3:
                      formRequestCarData['ExtraDriverContactId'] = extraContactId;
                      _context9.next = 4;
                      return carLoan.dispatch('create', formRequestCarData);
                    case 4:
                      result = _context9.sent;
                      if (!(result.status !== undefined && result.status !== 201)) {
                        _context9.next = 5;
                        break;
                      }
                      $f7.toast.show({
                        text: result.data.messages.error
                      });
                      return _context9.abrupt("return");
                    case 5:
                      $f7.views.main.router.navigate('/');
                      $f7.toast.show({
                        text: lang.translate('loan.request.messageSavedRequest')
                      });
                    case 6:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }));
              return function (_x5) {
                return _ref1.apply(this, arguments);
              };
            }());
          case 10:
          case "end":
            return _context0.stop();
        }
      }, _callee0);
    }));
    return function saveRequest() {
      return _ref0.apply(this, arguments);
    };
  }();
  var validateContactData = function validateContactData() {
    var isValid = true;
    for (var i = 0; i < extraDriverFields.length; i++) {
      var field = document.getElementById("extra-driver-contact-".concat(extraDriverFields[i]));
      if (field.value.length === 0) {
        var placeholder = field.getAttribute('placeholder');
        $f7.toast.show({
          text: lang.translate('loan.request.onEmptyFormField', [placeholder])
        });
        isValid = false;
        break;
      }
    }
    if (document.getElementById('extra-driver-contact-sex').selectedIndex === 0) {
      isValid = false;
    }
    return isValid;
  };
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab tab-active" id="tab-1-request">
  <div class="block">
    <div class="card card-outline-md demo-card-header-pic">
      <div style="background-image:url(${url}/${data.FilePath}/${data.FileName})" valign="bottom" class="card-header-big">
        ${data.CarManufacturerName} ${data.CarModel} ${data.CarYear}
      </div>
      <div class="card-content card-content-padding">
        <p class="data">€ ${data.CarPriceRent} ${lang.translate('general.perDay')}</p>
        <p><span class="data">${lang.translate('general.owner')}:</span> ${data.ContactName} ${data.ContactFirstLastName}</p>
        <div class="list accordion-list">
          <ul>
            <li class="accordion-item">
              <a class="item-link item-content">
                <div class="item-inner">
                  <div class="item-title">${lang.translate('car.dashboard.additionalData')}</div>
                </div>
              </a>
              <div class="accordion-item-content">
                <div class="block-title">${lang.translate('car.edit.carFeatureLabel')}</div>
                <${CarFeaturesReadOnly} list=${props.data.CarFeatureList} />
                <div class="block-title">${lang.translate('car.edit.carUseRestrictionLabel')}</div>
                <${CarFeaturesReadOnly} list=${props.data.CarUseRestrictionList} />
                <div class="block-title">${lang.translate('car.edit.penaltiesForMisusing')}</div>
                <${CarFeaturesReadOnly} list=${props.data.CarPenaltyUseList} />
                <${RatingDisplayMini} call-function="getLastRating" contact-id=${props.data.CarMainData.ContactId}/>
                <div class="block-title">${lang.translate('loan.request.aboutCarOwner')}:</div>
                <div class="block block-strong inset justify-content-center">${props.data.CarMainData.CarOwnerDescription}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <form id="request-car-form" class="list no-hairlines-md">
      <input id="car-loan-id" name="CarLoanId" type="hidden" value="${props.data.CarLoanData.CarLoanId}" />
      <input id="car-id" name="CarId" type="hidden" value="${props.data.CarMainData.CarId}" />
      <input id="car-price-per-day" name="CarPricePerDay" type="hidden" value="${props.data.CarLoanData.CarPricePerDay}" />
      <input id="days-to-borrow" name="DaysToBorrow" type="hidden" value="${props.data.CarLoanData.DaysToBorrow}" />
      <input id="total-to-pay" name="TotalToPay" type="hidden" value="${props.data.CarLoanData.TotalToPay}" />
      <input id="discounts" name="Discounts" type="hidden" value="${props.data.CarLoanData.Discounts}" />
      <input id="is-going-abroad" name="IsGoingAbroad" type="hidden" value="${props.data.CarLoanData.IsGoingAbroad}" />
      <input id="has-extra-driver" name="HasExtraDriver" type="hidden" value="0" />
      <input id="car-loan-start-date" name="CarLoanStartDate" type="hidden" value="${props.data.CarLoanData.CarLoanStartDate}"/>
      <input id="car-loan-end-date" name="CarLoanEndDate" type="hidden" value="${props.data.CarLoanData.CarLoanEndDate}"/>
      <ul>
        <li class="${props.data.CarLoanData.CarLoanId > 0 && $h`disabled`}">
          <label class="item-checkbox item-content item-checkbox-icon-end">
            <input id="borrower-acceptance-agreement" name="BorrowerAcceptanceAgreement" type="checkbox" checked="${props.data.CarLoanData.CarLoanId > 0 && $h`checked`}" />
            <i class="icon icon-checkbox"></i>
            <div class="item-inner">
              <div class="item-title">${lang.translate('user.newAccount.userAgreementCheckbox')}</div>
              <a href="/static/docs/DeLeenAuto-Agreement.pdf" class="external link color-red" target="_system">[${lang.translate('user.newAccount.userAgreementViewDoc')}]</a>
            </div>
          </label>
        </li>
        ${props.data.CarLoanData.CarLoanStatusId > 2 && $h`
        <li>
          <a class="list-button" @click="${downloadDocument}">
            <i class="icon material-symbols-outlined">download</i> ${lang.translate('general.document')}
          </a>
        </li>
        `}
        <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title">${lang.translate('car.edit.carPreferredDeliveryTime')}</div>
              <div class="item-after">${props.data.CarMainData.CarPreferredDeliveryTime}</div>
            </div>
          </div>
        </li>
        <li>
          <div class="item-content">
            <div class="item-inner">
              <div class="item-title">${lang.translate('car.edit.carPreferredReturnTime')}</div>
              <div class="item-after">${props.data.CarMainData.CarPreferredReturnTime}</div>
            </div>
          </div>
        </li>
        <li class="${props.data.CarLoanData.CarLoanId > 0 && $h`disabled`}">
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lang.translate('loan.request.loanPeriod')}</div>
              <div class="item-input-wrap">
                <input id="loan-period-range" name="PeriodRange" type="text" readonly="readonly" @click="${showRangeCalendar}"
                placeholder="${lang.translate('loan.request.loanRangeDatePlaceHolder')}" value="${calendarRangeDefaultValue}"/>
              </div>
            </div>
          </div>
        </li>
        <li class="${props.data.CarLoanData.CarLoanId > 0 && $h`disabled`}">
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lang.translate('loan.request.loanPeriodStartTime')}</div>
              <div class="item-input-wrap">
                <input id="loan-period-start-time" name="CarLoanStartTime" type="text" readonly="readonly" value="${props.data.CarLoanData.CarLoanStartTime}"/>
              </div>
            </div>
          </div>
        </li>
        <li class="${props.data.CarLoanData.CarLoanId > 0 && $h`disabled`}">
          <div class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lang.translate('loan.request.loanPeriodEndTime')}</div>
              <div class="item-input-wrap">
                <input id="loan-period-end-time" name="CarLoanEndTime" type="text" readonly="readonly" value="${props.data.CarLoanData.CarLoanEndTime}"/>
              </div>
            </div>
          </div>
        </li>
        <li class="${props.data.CarLoanData.CarLoanId > 0 && $h`disabled`}">
          <label class="item-content">
            <div class="item-inner">
              <div class="item-title">${lang.translate('loan.request.onlyDriver')}</div>
              <div class="item-after">
                <div class="toggle toggle-init">
                  <input id="get-extra-driver" name="GetExtraDriver" type="checkbox" checked="${props.data.ExtraDriverData.ContactId < 1 && $h`checked`}"  @click="${toggleExtraDriver}" />
                  <span class="toggle-icon"></span>
                </div>
              </div>
            </div>
          </label>
        </li>
        <li>
          <a id="buyout-options" class="item-link smart-select smart-select-init" data-searchbar="false">
            <select id="buyout-deposit-id" name="BuyoutDepositId" @change="${triggerCalc}">
              <option value="" selected><!--${lang.translate('general.select')}-->Deposit Fee [Deposit - Remaining] = Deposit Discount</option>
              ${buyoutList.length > 0 && $h`
                ${buyoutList.map((item) => $h`
              <option value="${item.BuyoutDepositId}" data-label="${item.BuyoutDepositRecommendationLabel}">€${item.BuyoutDepositFee} [€250 - €${item.BuyoutDepositToPay}] = €${Number(250-item.BuyoutDepositToPay)}*</option>
                `)}
              `}
            </select>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title">${lang.translate('loan.request.buyoutDeposit')}</div>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </form>
    <h5 id="recommendation-label">*${recommendationLabel}</h5>
    <form id="extra-driver-data-form">
      <input id="extra-driver-contact-id" type="hidden" value="${props.data.ExtraDriverData.ContactId}" />
      <div class="list accordion-list">
        <ul>
          <li class="accordion-item extra-driver">
            <a href="" class="item-link item-content">
              <div class="item-inner">
                <div class="item-title">${lang.translate('loan.request.extraDriverData')}</div>
              </div>
            </a>
            <div id="extra-driver-div" class="accordion-item-content disabled">
              <div class="list">
                <ul>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.personal.contactFirstName')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-name" name="ContactName" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactName}"
                           placeholder="${lang.translate('user.edit.personal.contactFirstName')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.personal.contactLastName')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-last-name" name="ContactLastName" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactFirstLastName}"
                           placeholder="${lang.translate('user.edit.personal.contactLastName')}" />
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <a class="item-link smart-select smart-select-init" data-searchbar="false">
                      <select id="extra-driver-contact-sex" name="ContactSex">
                        <option value="0" selected="${props.data.ExtraDriverData.ContactSex == 0 && $h`selected`}">${lang.translate('general.select')}</option>
                        <option value="1" selected="${props.data.ExtraDriverData.ContactSex == 1 && $h`selected`}">${lang.translate('user.edit.personal.contactGenderMale')}</option>
                        <option value="2" selected="${props.data.ExtraDriverData.ContactSex == 2 && $h`selected`}" >${lang.translate('user.edit.personal.contactGenderFemale')}</option>
                        <option value="3" selected="${props.data.ExtraDriverData.ContactSex == 3 && $h`selected`}" >${lang.translate('user.edit.personal.contactGenderX')}</option>
                      </select>
                      <div class="item-content">
                        <div class="item-inner">
                          <div class="item-title">${lang.translate('user.edit.personal.contactGenderLabel')}</div>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.personal.contactBirthDateLabel')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-birth-date" name="ContactBirthDate" type="text" readonly="readonly" @click="${showBirthCalendar}"
                           placeholder="${lang.translate('user.edit.personal.contactBirthDateLabel')}" value="${props.data.ExtraDriverData.ContactBirthDate}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.addressLabel')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-address" name="ContactAddress" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactAddress}"
                           placeholder="${lang.translate('user.edit.location.streetPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.streetLabel')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-address-street" name="ContactAddressStreet" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactAddressStreet}"
                           placeholder="${lang.translate('user.edit.location.streetPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.externalNumber')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-address-exterior-number" name="ContactAddressExteriorNumber" type="number" autocomplete="off" value="${props.data.ExtraDriverData.ContactAddressExteriorNumber}"
                           placeholder="${lang.translate('user.edit.location.externalNumberPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.district')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-district" name="ContactDistrict" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactDistrict}"
                           placeholder="${lang.translate('user.edit.location.districtPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.zipCode')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-zipcode" name="ContactZipcode" maxlength="7" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactZipcode}"
                           placeholder="${lang.translate('user.edit.location.zipCodePlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.phone')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-cellphone" name="ContactCellphone" maxlength="11" type="number" autocomplete="off" value="${props.data.ExtraDriverData.ContactCellphone}"
                           placeholder="${lang.translate('user.edit.location.phonePlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.email')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-email" name="ContactEmail" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactEmail}"
                           placeholder="${lang.translate('user.edit.location.emailPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="item-content item-input">
                      <div class="item-inner">
                        <div class="item-title item-label">${lang.translate('user.edit.location.locality')}</div>
                        <div class="item-input-wrap">
                          <input id="extra-driver-contact-locality" name="ContactLocalityName" type="text" autocomplete="off" value="${props.data.ExtraDriverData.ContactLocalityName}"
                           placeholder="${lang.translate('user.edit.location.localityPlaceHolder')}"/>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </form>
    ${props.data.CarLoanData.CarLoanId == 0 && $h`
    <div class="block block-strong">
      <p class="grid grid-cols-3 xlarge-grid-cols-3">
        <div></div>
        <div>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${saveRequest}">
            <span class="material-symbols-outlined">save</span>Request
          </a>
        </div>
        <div></div>
      </p>
    </div>
    `}
  </div>
</div>
`
    }
    ;
};
export default RequestTab;